import React from 'react'
import { Link } from 'react-router-dom'
import ls from 'local-storage'
import { connect } from 'react-redux';
// import JSEncrypt from 'jsencrypt'


import Header from '../components/header'
import Footer from '../components/footer'
import LoginModal from '../components/loginModal'
import SignupModal from '../components/signupModal'

import * as PrimaryServices from '../services/service'
import * as GlobalActions from '../store/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import * as SetWidget from '../operationalHelper/populateWidget'
import * as Const from '../constants/constants'


class ChatbotPolicy extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        document.title = "Chatbot Policy - Aviatrix"
        SetWidget.populateWidget()
    }



    render() {
        return (
            <React.Fragment>
                <div className="min-height-full">
                    {/* ==== Header for Page ==== */}
                    <Header parent="SLA"></Header>
                    <br />
                    <br />
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/> 
                    <div className="container width-wrapper pt-5 p-md-b-5">
                        <div className="row">
                        <p className="m-0 p-0 fs-6">
                                <strong>Aviatrix Chatbot Policy
                                    </strong>
                        </p>
                        <p className="m-0 pt-4 p-0 fs-2 ">
                        While Aviatrix AI Support chatbot is designed to assist users effectively, inaccuracies and biases may exist in AI-generated information. Aviatrix advises against relying solely on AI-generated content without verification, especially in cases of doubt or critical decision-making scenarios. If you are uncertain of the answer provided or have questions you can invoke the “Get more help” button that is presented to you to create a ticket with Aviatrix Support .                       
                         <br/><br/>
                       
                       Aviatrix explicitly disclaims any liability for inaccurate results or consequences arising from the reliance on AI-generated content.
                        </p>
                     
                       
                    
                        
                      
                       
                         
                      
                        
                        </div>
                        
                    </div>

                    {/* ==== Login Modal ==== */}
                    <LoginModal></LoginModal>

                    {/* ==== Sign up Modal ==== */}
                    <SignupModal></SignupModal>

                    {/* ==== Footer Component ==== */}
                    <Footer></Footer>
                    <br className="hide-on-mobile"/> 
                    <br className="hide-on-mobile"/> 
                    <br className="hide-on-mobile"/> 
                    

                </div>
            </React.Fragment >
        )
    }
}

export default ChatbotPolicy


// export default Home;